import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { hasSubscription, getCurrrentPlan } from '../../../helpers/state';
import { hasValidVideolandCookie } from '../../../helpers/authentication';
import { ROUTE_CHANGE_TIER_BEDROCK, ROUTE_HOME } from '../../../constants/Routes';
import { fetchTiers } from '../../../actions/tierActions';
import { isOnFreeTier } from '../../../helpers/tiers';
import { PARAM_NAMES } from '../../../constants/Checkout';
import { getConfig } from '../../../apiConfig';

export const useTierOptionsDataResolver = createUseTierOptionsDataResolver(
	useHistory,
	useDispatch,
	useSelector,
	hasValidVideolandCookie
);

export function createUseTierOptionsDataResolver(
	useHistory,
	useDispatch,
	useSelector,
	hasValidVideolandCookie
) {
	return function useTierOptionsDataResolver() {
		const history = useHistory();
		const dispatch = useDispatch();
		const hasVlCookie = hasValidVideolandCookie();
		const hasActiveSubscription = useSelector(hasSubscription);
		const currentPlan = useSelector(getCurrrentPlan);
		const tierId = currentPlan?.planDescription.tierId;
		const isUserOnFreeTier = isOnFreeTier(tierId);
		const { bedrock } = getConfig();

		useEffect(() => {
			const dispatchFetchTiers = () => dispatch(fetchTiers());
			async function redirect() {
				if (hasVlCookie) {
					if (hasActiveSubscription && tierId) {
						// set manually referrer to make work the cypress test redirectReason
						if (window.gigya?.cypressMock) {
							Object.defineProperty(document, 'referrer', {
								configurable: true,
								get: function () {
									return 'https://test.staging.videoland.com/';
								},
							});
						}
						if (isUserOnFreeTier && document.referrer.includes(bedrock)) {
							await history.replace(
								`${ROUTE_CHANGE_TIER_BEDROCK}?${PARAM_NAMES.REDIRECT_URL}=${ROUTE_HOME}`
							);
							return;
						} else {
							history.push(ROUTE_HOME);
						}
					} else {
						dispatchFetchTiers();
					}
				} else {
					dispatchFetchTiers();
				}
			}
			redirect();
		}, [dispatch, hasActiveSubscription, hasVlCookie, history, isUserOnFreeTier, tierId, bedrock]);
	};
}
